import CalendarIcon from "@redotech/redo-icons/calendar.svg";
import { DateFilterOperator } from "@redotech/redo-model/views/advanced-filters/date-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.shippedDate;

export const ShippedDateFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: CalendarIcon,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: DateFilterOperator.AFTER,
  },
  displayName: entry.displayName,
};
